/* import __COLOCATED_TEMPLATE__ from './video-thumbnail.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();